import { useCollection } from "../../hooks/useCollection";
import CSS from "./CSS.module.css";

const All = () => {
  const { documents } = useCollection("transportations");
  console.log(documents);
  return <main className={CSS.main}>{documents && "worked"}</main>;
};

export default All;
